import type { ProductSearch } from '@/entities/product';

export interface MaxViewedPosition {
  viewCard(position: number): void;
  getMaxViewedPosition(): number;
}

export function useMaxViewedPosition(productSearch: ProductSearch): MaxViewedPosition {
  let viewedSearchUuid: string | null = null;
  let maxViewedPosition = 0;

  const syncSearch = (): void => {
    if (productSearch.searchUuid === viewedSearchUuid) return;

    viewedSearchUuid = productSearch.searchUuid;
    maxViewedPosition = 0;
  };

  const viewCard = (position: number): void => {
    syncSearch();
    maxViewedPosition = Math.max(maxViewedPosition, position);
  };

  const getMaxViewedPosition = (): number => {
    syncSearch();
    return maxViewedPosition;
  };

  return { viewCard, getMaxViewedPosition };
}
